module.exports = __webpack_public_path__ + "static/img/water.43e85ac.png";